import { getAllProcedureParts, getFilterdProcedureParts } from '../../../redux/partSlice'
import { getProcedureRevisionsForPart } from '../../../redux/procedureRevisionSlice'

/**
 * When audit JSON lacks part_id_ref / procedure_rev_ref but has part number + rev label,
 * resolve UUIDs via procedure search APIs (same as Cancel navigation).
 */
export async function resolveProcedureIdsFromPartRevisionLabel(dispatch, {
  partId,
  revisionId,
  partNumber,
  revision,
}) {
  let partIdOut = partId
  let revisionIdOut = revisionId
  if ((!partIdOut || !revisionIdOut) && partNumber && revision != null) {
    const revNorm = String(revision).trim()
    const matchRev = (r) => {
      const rv = (r.rev ?? r.revision ?? r.label ?? '').toString().trim()
      return rv === revision || rv === revNorm || (r.rev ?? r.revision ?? '') === revision
    }
    const matchPartNum = (p) => {
      const pn = (p.part_number ?? p.partNumber ?? '').toString().trim()
      return pn === partNumber || pn === String(partNumber).trim()
    }
    const partRefFromRow = (row) =>
      row?.part_id ?? row?.part_ref ?? row?.part_ref_id ?? row?.part_id_ref
    const revisionIdFromRow = (row) =>
      row?.procedure_revision_id ?? row?.id ?? row?.revision_id

    try {
      const searchRes = await dispatch(
        getFilterdProcedureParts({ query: partNumber })
      ).unwrap()
      const searchResults =
        searchRes?.results ??
        searchRes?.tableOfProcedures ??
        searchRes?.data ??
        (Array.isArray(searchRes) ? searchRes : [])
      const revRow =
        searchResults.find(
          (r) => matchRev(r) && (!partNumber || matchPartNum(r))
        ) ?? searchResults.find(matchRev)
      if (revRow) {
        partIdOut = partIdOut || partRefFromRow(revRow)
        revisionIdOut = revisionIdOut || revisionIdFromRow(revRow)
      }
    } catch (_) {
      /* ignore */
    }

    if (!partIdOut || !revisionIdOut) {
      try {
        const partsPayload = await dispatch(
          getAllProcedureParts({ limit: 50, offset: 0, partNumber, type: '' })
        ).unwrap()
        let parts =
          partsPayload?.results ??
          (Array.isArray(partsPayload) ? partsPayload : [])
        if (!Array.isArray(parts)) parts = []
        let part = parts.find(matchPartNum) || parts[0]
        if (!part && partNumber) {
          const allRes = await dispatch(
            getAllProcedureParts({ limit: 100, offset: 0, partNumber: '', type: '' })
          ).unwrap()
          const allParts = allRes?.results ?? (Array.isArray(allRes) ? allRes : [])
          part = Array.isArray(allParts) ? allParts.find(matchPartNum) : null
        }
        const resolvedPartId =
          part?.part_id ?? part?.part_ref ?? part?.id ?? part?.part_id_ref
        if (resolvedPartId) {
          partIdOut = partIdOut || resolvedPartId
          if (!revisionIdOut) {
            const revRes = await dispatch(
              getProcedureRevisionsForPart({ partId: resolvedPartId })
            ).unwrap()
            const revisions = revRes?.results ?? (Array.isArray(revRes) ? revRes : [])
            const revRow = Array.isArray(revisions) ? revisions.find(matchRev) : null
            revisionIdOut = revisionIdFromRow(revRow) || revisionIdOut
          }
        }
      } catch (_) {
        /* keep partIdOut/revisionIdOut */
      }
    }
  }
  return { partId: partIdOut, revisionId: revisionIdOut }
}
